<template>
  <ValidationProvider
    :name="name||placeholder"
    :rules="validationRules"
    v-slot="{ errors }"
  >
    <label>{{ name }}</label>
    <v-select
      :dir="$vs.rtl ? 'rtl' : 'ltr'"
      :label="label"
      :multiple="multiple"
      :options="options"
      :placeholder="placeholder"
      :reduce="reduce"
      v-model="computedValue"
      :disabled="disabled"
    >
      <template v-if="$scopedSlots.option" #option="option">
        <slot name="option" v-bind="option" />
      </template>
    </v-select>
    <span class="text-danger">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
import vSelect from 'vue-select';

export default {
  name: "TmSelect",
  props: {
    name: {type: String, required: false, default: null},
    value: {type: [Number, String, Array, Object]},
    placeholder: {type: String, default: null},
    validationRules: {type: [String, Object], required: true},
    options: {type: Array, required: true},
    label: {type: String, default: null},
    reduce: {type: Function, default: null},
    multiple: {type: Boolean, default: false},
    disabled: { type: Boolean, required: false, default: false },

  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    }
  },

  components: {
    vSelect
  }
};
</script>


<style>
.v-select {
  position: relative !important;
}
.v-select .vs__dropdown-menu {
  position: sticky !important;
  top: auto !important;
  left: auto !important;
  min-width: inherit !important;
  width: auto !important;
  z-index: 9999;
}
</style>